import { createCirclePolygon } from './shapes.js';
export const createCountersinkHolePolygon = (hole)=>{
    const { $absCoords: center, bottomRadius } = hole;
    return createCirclePolygon({
        center,
        radius: bottomRadius
    });
};

//# sourceMappingURL=countersink-hole.js.map